import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { ModalConfirm } from '../../models/modal-confirm';

@Component({
  selector: 'app-pcconfrim-modal',
  templateUrl: './pcconfrim-modal.component.html',
  styleUrls: ['./pcconfrim-modal.component.css'],
})
export class PCConfrimModalComponent {
  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'Enter') {
        this.ok();
      }
      if (e.key == 'Escape') {
        this.cancel();
      }
    });
  }

  public loading:boolean=false;

  @Output() childEvent = new EventEmitter<PCTableOutputModel>();

  @Input() inputModel!: ModalConfirm;

  cancel() {
    this.childEvent.emit(
      new PCTableOutputModel(this.inputModel.returnDenyMethod, undefined)
    );
  }

  ok() {
    this.loading=true;
    this.childEvent.emit(
      new PCTableOutputModel(this.inputModel.returnAcceptMethod, undefined)
    );
  }
}
